import { makeStyles } from "@material-ui/core";

export const vendaSearchStyles = makeStyles({
  searchHeaderVendas: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    maxWidth: '512px'
  },
  link: {
    color: '#53c4e6',
    fontWeight: '600',
    textTransform: 'initial',
  },
})